var map = {
	"./i/b.jpg": "42b7",
	"./ii/b.jpg": "e014",
	"./iii/b.jpg": "ded5",
	"./iv/b.jpg": "f5c2",
	"./ix/b.jpg": "d101",
	"./v/b.jpg": "de5b",
	"./vi/b.jpg": "4987",
	"./vii/b.jpg": "ec67",
	"./viii/b.jpg": "7546",
	"./writing/b.jpg": "d319",
	"./x/b.jpg": "67d5",
	"./xi/b.jpg": "66ff",
	"./xii/b.jpg": "48a8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fbaf";